import React from 'react'

const Footer = () => {
  return (
    <footer>
      <span>Typemaster 2021</span> |  All Rights Reserved
    </footer>
  )
}

export default Footer